import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { notification } from 'antd';
import SpinnerFullScreen from '../spinner/SpinnerFullScreen';
import useInitialLoader from '../spinner/useInitialLoader';
import PublicDashboardFirstStep from './PublicDashboardFirstStep';
import Search from '../../pages/Search/Search';
import useSearchDashboard from '../../hooks/useSearchDashboard';
import { HOME } from '../../constants/routes';
import { t } from '../../i18n/i18n';
import { hasDashboardInvite } from '../../API/services/dashboardInvitation';
import { setCurrentWorkspace } from '../../redux/actions/authActions';

const PublicDashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const initialLoading = useInitialLoader();
  const { id } = useParams();
  const { selectedSearch } = useSearchDashboard(id);
  const { authenticated: isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (selectedSearch?.workspaceId) {
      localStorage.setItem('workspaceInfo', JSON.stringify({ id: selectedSearch.workspaceId }));
      dispatch(setCurrentWorkspace(selectedSearch.workspaceId));
    }
  }, [selectedSearch?.workspaceId]);

  useEffect(() => {
    const checkInvite = async () => {
      if (isAuthenticated) {
        try {
          const hasInvite = await hasDashboardInvite(id);
          if (!hasInvite) {
            notification.warning({
              message: t('PUBLIC_DASHBOARD_NO_GUEST_TITLE'),
              description: t('PUBLIC_DASHBOARD_NO_GUEST_DESCRIPTION'),
              placement: 'topRight',
            });
            history.push(HOME);
          }
        } catch (error) {
          const backendMessage = error?.response?.data?.message;
          if (backendMessage.includes('DASHBOARD_INVITATION_EXPIRED')) {
            notification.warning({
              message: t('PUBLIC_DASHBOARD_INVITATION_EXPIRED_TITLE'),
              description: t('PUBLIC_DASHBOARD_INVITATION_EXPIRED_DESCRIPTION'),
              placement: 'topRight',
              duration: 10,
            });
            history.push(HOME);
          }
          history.push(HOME);
        }
      }
    };
    checkInvite();
  }, [isAuthenticated, id]);

  if (initialLoading) {
    return <SpinnerFullScreen show whiteBackground />;
  }

  return isAuthenticated ? <Search /> : <PublicDashboardFirstStep recruitSessionId={id} />;
};

export default PublicDashboard;
